const Error = () => {
    return (
        <h1>Sorry there was an error</h1>
    )
}
export default Error;